export default {
  home: {
    title: 'HTML5 게임 컬렉션',
    subtitle: '브라우저에서 즉시 플레이. 다운로드 없이 바로 즐기세요!',
    browseGames: '게임 둘러보기',
    popularGames: '인기 게임',
    newGames: '신규 게임',
    recommendedGames: '추천 게임',
    recentlyPlayed: '최근 플레이한 게임',
    popular: '인기',
    genres: {
      casual: '캐주얼',
      puzzle: '퍼즐',
      racing: '레이싱',
      racing_driving: '레이싱 & 드라이빙',
      shooter: '슈팅',
      simulation: '시뮬레이션',
      strategy: '전략',
      sports: '스포츠',
      agility: '민첩성',
      battle: '배틀',
      care: '케어',
      cooking: '요리',
      football: '축구',
      '.IO': '실시간 대전',
      merge: '병합',
      all: '전체',
      other: '기타',
      dressup: '드레스업',
      adventure: '어드벤처',
      mahjong_connect: '마작 & 연결',
      jigsaw: '직소 퍼즐',
      basketball: '농구',
      quiz: '퀴즈',
      bubble_shooter: '버블 슈터',
      match3: '매치3',
      boardgames: '보드게임',
      educational: '교육',
      cards: '카드'
    }
  },
  games: {
    playNow: '지금 플레이',
    relatedGames: '관련 게임',
    instructions: '게임 설명',
    controlsTitle: '게임 컨트롤',
    addToFavorites: '즐겨찾기에 추가',
    removeFromFavorites: '즐겨찾기에서 제거',
    share: '게임 공유',
    reportIssue: '문제 신고',
    fullscreen: '전체 화면',
    exitFullscreen: '전체 화면 종료'
  },
  categories: {
    title: '게임 카테고리',
    subtitle: '다양한 게임 카테고리를 탐색해 보세요',
    allCategories: '모든 카테고리',
    gamesInCategory: '게임 {count}개',
    categoryDescription: '여기에서 {category} 카테고리의 모든 게임을 찾을 수 있습니다. 다양한 스타일에서 선택하고 바로 플레이를 시작하세요!',
    pageTitle: '게임 카테고리',
    pageDescription: '다양한 게임 카테고리를 탐색하고 좋아하는 게임 유형을 찾아보세요',
    allGames: '모든 게임',
    gamesFound: '게임 {count}개를 찾았습니다',
    other: '기타',
    taggedGames: '{tag} 게임',
    noGamesInCategory: '이 카테고리에 게임이 없습니다',
    loadMore: '더 불러오기',
    otherGames: '기타 게임',
    seoTitle: 'GoGameVault - 게임 카테고리 | 무료 온라인 HTML5 게임',
    seoDescription: 'GoGameVault의 다양한 게임 카테고리를 탐색하고 액션, 퍼즐, 아케이드, 스포츠, 레이싱 등 좋아하는 게임 유형을 찾아보세요.',
    seoKeywords: '게임 카테고리,온라인 게임,무료 게임,HTML5 게임,브라우저 게임',
    descriptions: {
      'Casual': '모든 연령대의 플레이어에게 적합한 쉽고 간단한 캐주얼 게임, 부담 없이 게임을 즐기세요.',
      'Puzzle': '퍼즐과 지적 도전을 통해 만족감을 주는 두뇌 훈련 퍼즐 게임.',
      'Racing & Driving': '스릴 넘치는 레이싱과 드라이빙 게임에서 속도와 흥분을 경험하세요.',
      'Shooter': '조준 정확도와 반응 속도가 시험되는 슈팅 게임, 모든 적을 물리치세요.',
      'Simulation': '도시 경영부터 비행기 조종까지, 현실 세계의 다양한 경험을 시뮬레이션합니다.',
      'Strategy': '신중한 계획과 전술적 사고가 필요한 전략 게임, 최적의 전략으로 승리하세요.',
      'Sports': '다양한 스포츠를 시뮬레이션하는 스포츠 게임, 당신의 운동 능력을 뽐내보세요.',
      'Agility': '반응 속도와 조정 능력이 시험되는 민첩성 게임, 다양한 도전에 빠르게 대응하세요.',
      'Battle': '상대방과 치열하게 경쟁하는 배틀 게임, 기술과 전략으로 승리를 쟁취하세요.',
      'Care': '애완동물, 환자 또는 다른 캐릭터를 돌보는 즐거움을 경험하는 케어 게임.',
      'Cooking': '요리 실력을 뽐내고, 맛있는 요리를 만들어 레스토랑을 경영하는 요리 게임.',
      'Football': '세계에서 가장 인기 있는 스포츠를 경험하고, 축구 기술과 전술을 뽐내보세요.',
      '.IO': '실시간 대전 게임, 전 세계 플레이어와 경쟁하고 성장하는 멀티플레이어 온라인 대전 게임.',
      'Merge': '동일한 아이템을 조합하여 새로운 아이템을 만드는 간단하고 재미있는 병합 게임.',
      'other': '일반적인 카테고리에 속하지 않는 독특한 게임 경험.',
      'generic': '다양한 {tag} 게임을 탐색하고 즐겨찾기를 찾아보세요.'
    }
  },
  search: {
    title: '검색 결과',
    placeholder: '게임 검색...',
    resultsFor: '"{query}"에 대한 검색 결과',
    noResults: '게임을 찾을 수 없습니다',
    noResultsMessage: '"{query}"와 관련된 게임을 찾을 수 없습니다',
    tryAgain: '다른 키워드를 시도하거나 카테고리를 탐색해 보세요.',
    returnToHomepage: '홈페이지로 돌아가기',
    foundResults: '게임 {count}개를 찾았습니다',
    seoTitle: '"{query}" 검색 - GoGameVault | 무료 온라인 HTML5 게임',
    seoDescription: 'GoGameVault에서 "{query}"와 관련된 무료 온라인 HTML5 게임을 검색하세요. 다양한 재미있는 게임을 다운로드 없이 브라우저에서 직접 플레이할 수 있습니다.'
  },
  gameDetail: {
    title: '게임 상세',
    gameTitle: '게임 제목',
    genres: '게임 장르',
    tags: '태그',
    gameDescription: '게임 설명',
    controlsAndInstructions: '컨트롤 및 설명',
    similarGames: '유사한 게임',
    new: '새 게임',
    playAmazingGame: '이 놀라운 게임을 지금 플레이하세요',
    noSimilarGames: '유사한 게임이 없습니다',
    gameNotFound: '게임을 찾을 수 없습니다',
    gameNotExistOrRemoved: '이 게임은 존재하지 않거나 삭제되었습니다',
    backToHome: '홈페이지로 돌아가기',
    seoTitle: '{title} - 무료로 온라인 플레이 | GoGameVault',
    seoTitleNotFound: '게임을 찾을 수 없습니다 | GoGameVault',
    seoKeywords: '{title}, 온라인 게임, 무료 게임, {tags}, HTML5 게임',
    gameUnavailable: '게임을 일시적으로 사용할 수 없습니다',
    tryAgainLater: '나중에 다시 시도해 주세요',
    share: '공유',
    openInNewTab: '새 탭에서 열기'
  },
  about: {
    title: '회사 소개',
    aboutUs: '회사 소개',
    ourMission: '우리의 미션',
    contactUs: '문의하기',
    privacyPolicy: '개인정보 처리방침',
    termsOfService: '서비스 이용약관',
    feedbackTitle: '피드백',
    feedbackText: '저희는 항상 웹사이트를 개선하기 위해 노력하고 있습니다. 제안이나 문제가 있으시면 알려주세요!',
    missionTitle: '우리의 미션',
    missionText1: 'GoGameVault는 사용자에게 최고의 무료 온라인 게임 경험을 제공하는 데 전념하고 있습니다. 다운로드 없이 즐길 수 있는 재미있고 고품질의 HTML5 게임을 엄선하고 있습니다.',
    missionText2: '우리의 목표는 플레이어가 좋아하는 게임을 쉽게 찾고 플레이할 수 있는 사용자 친화적인 게임 플랫폼을 만드는 것입니다.',
    feature1Title: '엄선된 게임',
    feature1Text: '고품질 그래픽과 원활한 게임 플레이를 보장하기 위해 각 게임을 신중하게 선택하고 있습니다.',
    feature2Title: '언제 어디서나 플레이',
    feature2Text: '모든 게임은 추가 소프트웨어 다운로드나 설치 없이 브라우저에서 직접 실행됩니다.',
    feature3Title: '완전 무료',
    feature3Text: '우리의 모든 게임은 숨겨진 요금이나 앱 내 구매 없이 완전히 무료입니다.',
    contactTitle: '문의하기',
    contactText: '질문, 제안, 피드백이 있으시면 언제든지 문의해 주세요. 우리는 사용자의 의견을 중요시하며 서비스를 지속적으로 개선하기 위해 노력하고 있습니다.',
    seoTitle: 'GoGameVault - 회사 소개 | 무료 온라인 HTML5 게임',
    seoDescription: 'GoGameVault는 다운로드 없이 어디서나 플레이할 수 있는 엄선된 게임을 제공하는 무료 온라인 HTML5 게임 플랫폼입니다. 우리의 미션과 특징에 대해 알아보세요.',
    seoKeywords: '온라인 게임,무료 게임,HTML5 게임,브라우저 게임,다운로드 불필요'
  },
  notFound: {
    title: '페이지를 찾을 수 없습니다',
    message: '죄송합니다. 접근하신 페이지가 존재하지 않거나 삭제되었습니다. 원래 궤도로 돌아가 봅시다!',
    returnHome: '홈페이지로 돌아가기',
    goBack: '뒤로 가기',
    popularGames: '인기 게임 추천',
    popularGamesDesc: '이 특집 게임들을 탐색하고 게임 여정을 시작해 보세요',
    seoTitle: '페이지를 찾을 수 없습니다 - GoGameVault',
    seoDescription: '죄송합니다. 접근하신 페이지는 GoGameVault에 존재하지 않습니다. 새로운 게임 경험을 위해 인기 게임을 탐색해 보세요.'
  },
  categoryGames: {
    games: '게임',
    gamesAvailable: '게임 {count}개 이용 가능',
    noGamesFound: '게임을 찾을 수 없습니다',
    noGamesInCategory: '이 카테고리에 게임이 없습니다',
    exploreCategories: '다른 카테고리 탐색',
    backToCategories: '카테고리로 돌아가기',
    invalidCategory: '잘못된 카테고리',
    categoryNotExist: '찾으시는 카테고리가 존재하지 않습니다.',
    browseCategories: '모든 카테고리 탐색',
    category: '카테고리',
    seoTitle: '{tag} 게임 - 온라인으로 플레이 - GoGameVault',
    seoDescriptionWithGames: '{count}개의 특집 {tag} 게임을 무료로 탐색하고 플레이하세요. 모든 게임은 다운로드 없이 브라우저에서 직접 플레이할 수 있습니다.',
    seoDescriptionDefault: '우리의 {tag} 게임을 무료로 탐색하고 플레이하세요. 모든 게임은 다운로드 없이 브라우저에서 직접 플레이할 수 있습니다.',
    seoKeywords: '{tag} 게임,무료 온라인 게임,브라우저 게임'
  }
}; 